import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { ProductType } from "./cart.state";
import { PaymentIntent, PaymentMethod } from "@stripe/stripe-js";


export const CartActions = createActionGroup({
    source: 'cart',
    events: {
        'Clear Cart': emptyProps(),
        'Add Product': props<{ productId: string }>(),
        'Set Product Data': props<{ product: any }>(),
        'Set Product Type': props<{ productType: ProductType }>(),
        'Set Payment Intent': props<{ paymentIntent: PaymentIntent }>(),
        'Start Loading': emptyProps(),
        'Stop Loading': emptyProps(),
        'set IsMigration': props<{ isMigration: boolean }>(),
        'set Family Option': props<{ isFamily: boolean }>(),
        'Set Stripe Payment Method': props<{ stripePaymentMethod: PaymentMethod | string }>(),
        'Remove Stripe Payment Method': emptyProps(),
    }
})